// extracted by mini-css-extract-plugin
export var defaultWrapper = "_na-3";
export var downloadButton = "_na-4";
export var fileContainer = "_na-9 _na-7";
export var fileContainerBase = "_na-7";
export var fileContainerFixedHeight = "_na-8 _na-7";
export var fileInfo = "_na-5";
export var fileInfoWidthRestricted = "_na-6";
export var fileType = "_na-1";
export var fileTypeName = "_na-2";
export var image = "_na-0";
export var link = "_na-b";
export var overflowEllipsis = "_na-a";